import { Component, OnInit } from '@angular/core';
import { UserService } from 'services/user.service';

@Component({
  selector: 'app-front-page',
  templateUrl: './front-page.component.html',
  styleUrls: ['./front-page.component.css']
})
export class FrontPageComponent implements OnInit {
  public loginDisplay = false;
  public username = '';

  constructor(private _userService: UserService) {}

  ngOnInit(): void {
    this.loginDisplay = this._userService.isLoggedIn();
    if (this.loginDisplay) {
      this.username = this._userService.getUsername();
    }
  }
}
